import { ApplicationVersion } from '@raydiant/api-client-js';

export const getVersionText = (version: ApplicationVersion) => {
  return `${version.majorVersion}.${version.minorVersion}.${version.patchVersion}`;
};

export const isVersionApproved = (version: ApplicationVersion) => {
  return version.reviewStatus === 'approved';
};
